import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { User, Mail, Download, RefreshCw } from 'lucide-react';
import { exportToCSV, formatDate } from '../../lib/admin/utils';

const SubscribersTab = ({ subscribers, loading, onRefresh }) => (
  <div className="space-y-4">
    <div className="flex justify-between items-center">
      <h2 className="text-xl font-semibold text-gray-900">Newsletter Subscribers</h2>
      <div className="flex gap-2">
        <Button onClick={onRefresh} variant="outline" size="sm">
          <RefreshCw className="w-4 h-4 mr-2" />
          Refresh
        </Button>
        <Button
          onClick={() => exportToCSV(subscribers, 'newsletter-subscribers')}
          className="bg-[#FDB913] hover:bg-[#E5A50A] text-gray-900"
          size="sm"
        >
          <Download className="w-4 h-4 mr-2" />
          Export CSV
        </Button>
      </div>
    </div>

    {loading ? (
      <div className="text-center py-12">Loading...</div>
    ) : subscribers.length === 0 ? (
      <Card>
        <CardContent className="py-12 text-center text-gray-500">No subscribers yet</CardContent>
      </Card>
    ) : (
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {subscribers.map((subscriber) => (
          <Card
            key={subscriber._id || subscriber.email}
            className="hover:shadow-lg transition-shadow"
          >
            <CardContent className="pt-6">
              <div className="flex items-center gap-2 mb-3">
                <User className="w-5 h-5 text-[#FDB913]" />
                <span className="font-semibold">
                  {subscriber.firstName} {subscriber.lastName}
                </span>
              </div>
              <div className="space-y-2 text-sm">
                <div className="flex items-center gap-2">
                  <Mail className="w-4 h-4 text-gray-500" />
                  <a href={`mailto:${subscriber.email}`} className="text-blue-600 hover:underline truncate">
                    {subscriber.email}
                  </a>
                </div>
                <div className="text-xs text-gray-500">Subscribed: {formatDate(subscriber.subscribedAt)}</div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    )}
  </div>
);

export default SubscribersTab;
